import { Component, Inject, OnInit, QueryList, ViewChildren } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CommonService } from "src/app/Service/Common.service";
import { NotificationService } from "src/app/Service/notification.service";
import { IElementInputModel } from "src/app/ViewModel/DocumentModel";
import { StandardOutputModel } from "src/app/ViewModel/StandardOutputModel";
import { ScheduleCreationComponent } from "../schedule-creation/schedule-creation.component";
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-bulk-schedule-upload',
    templateUrl: './bulk-schedule-upload.component.html',
    styleUrls: ['./bulk-schedule-upload.component.css']
})
export class BulkScheduleUploadComponent implements OnInit {
    @ViewChildren(ScheduleCreationComponent) scheduleCreationComp!: QueryList<ScheduleCreationComponent>;
    public noOfDocsArr: number[] = [];
    public noOfDocs: number;
    public isStdDCI: boolean;
    public numFormat = 'Auto';
    public readonly = true;
    public projectId: number = 0;
    public groupId: number = 0;
    public memberId: number = 0;
    public CurrentProjectDetails!: ProjectViewModel;
    public canManualNo: boolean = false;
    public rateControl = new FormControl("", [Validators.max(5), Validators.min(1)])
    autoSerialNoMap: Map<number, number> = new Map<number, number>();
    sourceDciComponent: ScheduleCreationComponent | undefined;
    autoSerialSelectedValues: Map<number, IElementInputModel[]> = new Map<number, IElementInputModel[]>();
    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<BulkScheduleUploadComponent>, private _notificationService: NotificationService, private commonService: CommonService, private dialog: MatDialog) {
        this.noOfDocs = this.data.num;
        this.isStdDCI = this.data.isStdDCI;
    }
    ngOnInit() {
        this.projectId = this.commonService.getProjectId();
        this.memberId = this.commonService.getLoggedInUserId();
        this.groupId = this.commonService.getLoggedInUserGroupId();
        this.CurrentProjectDetails = this.commonService.getCurrentProjectDetails();
        if (this.CurrentProjectDetails && this.CurrentProjectDetails.doc_Number_Format) {
            this.numFormat = this.CurrentProjectDetails.doc_Number_Format;
        }
        this.callMemberRoleandFeature();
        for (let i = 0; i < this.noOfDocs; i++) {
            this.noOfDocsArr.push(i);
        }
        if (this.isStdDCI) {
            this.numFormat = 'Auto';
        }
    }

    addDocument() {
        this.sourceDciComponent = this.scheduleCreationComp.find(x => x.docIndex == 1)
        let count = this.rateControl.value;
        let previousCount = this.noOfDocsArr.length;
        if (count > 5) {
            count = 5;
        }
        if (previousCount < count) {
            for (let i = previousCount; i < count; i++) {
                this.noOfDocsArr.push(i);
            }
        } else {
            let countdiff = previousCount - count;
            for (let i = 0; i < countdiff; i++) {
                this.noOfDocsArr.splice(previousCount - 1, countdiff);
                previousCount = previousCount - 1;
            }
        }
    }

    closeDialog(isSaveAndAddNew: boolean) {
        this.dialogRef.close(isSaveAndAddNew);
    }

    async saveScheduleDoc(isSaveAndAddNew: boolean) {
        let results: StandardOutputModel[] = [];
        let failureResult: string = "";
        // validation handling before back end responce
        for (let i = 0; i < this.scheduleCreationComp.length; i++) {
        let schCreationComp: ScheduleCreationComponent = this.scheduleCreationComp.toArray()[i];
        var count: any = schCreationComp.madatoryFieldsValidation();
        if (!!count)
            results.push(count);
        }
        if(count == undefined){
            for (let i = 0; i < this.scheduleCreationComp.length; i++) {
                let schCreationComp: ScheduleCreationComponent = this.scheduleCreationComp.toArray()[i];
                let x: StandardOutputModel = await schCreationComp.saveDocument();
                if (!!x)
                    results.push(x);
            }
        }
      
        let successResult: string = "";
        results.forEach(res => {
            if (!!res) {
                if (res.successCode == 200)
                    successResult += res.successMessage + "<br>";
                else {
                    failureResult += res.successMessage + "<br>";
                }
            }
        });
        if (failureResult && failureResult.length > 0) {
            this._notificationService.showPopup(failureResult, "Warning");
            //Popup should be closed when saving more than one document 
            // if (results.length > 1) {
            //     this.closeDialog(isSaveAndAddNew);
            // }
        }
        if (successResult && successResult.length > 0) {
            this._notificationService.showPopup(successResult, "Success");
            this.closeDialog(isSaveAndAddNew);
        }
    }


    onValChange(value: string) {
        this.numFormat = value;
    }

    getDocumentSerialNo(value: any) {
        this.autoSerialSelectedValues.set(value.index, value.selectedDedIds);
        this.autoSerialNoMap.set(value.index, value.serialNo);
        if (this.autoSerialSelectedValues.size > 1) {
            this.autoSerialSelectedValues.forEach((x, y) => {
                if (y != value.index && JSON.stringify(x) == JSON.stringify(value.selectedDedIds)) {
                    let val=this.autoSerialNoMap.get(y);
                    if(val)
                    this.autoSerialNoMap.set(value.index, val + 1)
                }
            })
        }
    }

    resetBulkSchedule() {
        this.scheduleCreationComp.forEach(x => x.resetScheduleForm());
    }

    async callMemberRoleandFeature() {
        this.commonService.getProjectMemberRoles(this.projectId, this.groupId, this.memberId).subscribe((result: any[]) => {

        });
        await this.commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId).subscribe((result1: any[]) => {
            this.canManualNo = result1.some(data => data.feature_Desc == 'Manual No');
            if (!this.canManualNo && this.numFormat == 'Manual')
                this.numFormat = 'Auto';
        });
    }

}